var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoffee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 58 43",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.611 34.61a1 1 0 0 1-.49-1.872 12.919 12.919 0 0 1 3.436-1.273c.384-.089.8-.176 1.225-.268 3.8-.81 8.531-1.819 9.147-6.332.045-.333.068-.669.071-1.005v-4.379a1 1 0 0 1 2 0v4.379c-.003.423-.032.845-.088 1.264-.808 5.918-6.768 7.188-10.713 8.029-.418.089-.818.175-1.194.262a10.941 10.941 0 0 0-2.905 1.067 1 1 0 0 1-.489.128z",
    fill: "#95a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 19.25v4.61c0-5.24-5.59-5.89-10.08-4.36h-.04C47 18 47.03 18.24 47 17l1.99-2.14a.06.06 0 0 0 .04-.01c4.47-1.48 9.97-.79 9.97 4.4z",
    fill: "#d1d4d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.99 15.24c.03 1.24.01 2.69-.11 4.26a30.388 30.388 0 0 1-4.27 14.11C41.2 38.89 35.26 43 25 43 2.92 43 .81 23.93 1.01 15.24z",
    fill: "#bdc3c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 15a.448.448 0 0 1-.01.11c.01.02 0 .03 0 .05a.11.11 0 0 1 0 .08C48.79 23.41 38.12 30 25 30S1.21 23.41 1.01 15.24a.11.11 0 0 1 0-.08c0-.02-.01-.03 0-.05A.448.448 0 0 1 1 15C1 6.72 11.75 0 25 0s24 6.72 24 15z",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 15,
    fill: "#a56a43",
    rx: 20,
    ry: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 27C13.225 27 4 21.729 4 15S13.225 3 25 3s21 5.271 21 12-9.225 12-21 12zm0-22C14.7 5 6 9.58 6 15s8.7 10 19 10 19-4.58 19-10S35.3 5 25 5z",
    fill: "#bdc3c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 40c-6.47 0-11.508-1.8-14.975-5.352a1.001 1.001 0 0 1 1.432-1.4C14.536 36.4 19.093 38 25 38a1 1 0 0 1 0 2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 15a1 1 0 0 0-1 1c0 2.542-4.028 4.714-9 4.974v-2.022c3.162-.233 5.293-1.51 5.837-2.452a.966.966 0 0 0-.345-1.307 1.035 1.035 0 0 0-1.377.292A6.741 6.741 0 0 1 26 16.952v-2.226c3.965-1.281 6-2.866 6-4.726 0-1.71-1.72-3-4-3a6.258 6.258 0 0 0-3 .706A6.258 6.258 0 0 0 22 7c-2.28 0-4 1.29-4 3 0 1.86 2.035 3.445 6 4.726v2.226a6.812 6.812 0 0 1-4.106-1.452 1 1 0 1 0-1.731 1c.544.942 2.675 2.219 5.837 2.452v2.022c-4.972-.26-9-2.432-9-4.974a1 1 0 0 0-2 0c0 3.925 5.271 7 12 7s12-3.075 12-7a1 1 0 0 0-1-1z",
    fill: "#fdd7ad"
  }))));
}

export default SvgCoffee;